import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleCreateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchModuleCreate = createAsyncThunk(
    'moduleCreate/fetchModuleCreate',
    async ({ file, pageId, Name, SpecialField1 }) => {
        const response = await ModuleCreateService(file, pageId, Name, SpecialField1)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const moduleCreateSlice = createSlice({
    name: 'moduleCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleCreateSlice.reducer;
